class CartDrawer extends HTMLElement {
    constructor() {
        super();

        this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
        this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
        this.setHeaderCartIconAccessibility();

        initUpsells()
    }

    setHeaderCartIconAccessibility() {
        const cartLink = document.querySelector('#cart-icon-bubble');
        cartLink.setAttribute('role', 'button');
        cartLink.setAttribute('aria-haspopup', 'dialog');
        cartLink.addEventListener('click', (event) => {
            event.preventDefault();
            this.open(cartLink);
        });
        cartLink.addEventListener('keydown', (event) => {
            if (event.code.toUpperCase() === 'SPACE') {
                event.preventDefault();
                this.open(cartLink);
            }
        });
    }

    open(triggeredBy) {
        //this.querySelector('[data-content="drawer-upsells"]').classList.toggle('minimized', sessionStorage.getItem('upsellDisplayed') === "false")

        if (triggeredBy) this.setActiveElement(triggeredBy);
        const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
        if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
        // here the animation doesn't seem to always get triggered. A timeout seem to help
        setTimeout(() => {
            this.classList.add('animate', 'active');
            //handleComponentVisibility('open')
        });

        this.addEventListener(
            'transitionend',
            () => {
                const containerToTrapFocusOn = this.classList.contains('is-empty')
                    ? this.querySelector('.drawer__inner-empty')
                    : document.getElementById('CartDrawer');
                const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
                trapFocus(containerToTrapFocusOn, focusElement);
            },
            { once: true }
        );

        document.body.classList.add('overflow-hidden');
    }

    close() {
        this.classList.remove('active');
        removeTrapFocus(this.activeElement);
        document.body.classList.remove('overflow-hidden');
    }

    setSummaryAccessibility(cartDrawerNote) {
        cartDrawerNote.setAttribute('role', 'button');
        cartDrawerNote.setAttribute('aria-expanded', 'false');

        if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
            cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
        }

        cartDrawerNote.addEventListener('click', (event) => {
            event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
        });

        cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
    }

    renderContents(parsedState) {
        this.querySelector('.drawer__inner').classList.contains('is-empty') &&
            this.querySelector('.drawer__inner').classList.remove('is-empty');
        this.productId = parsedState.id;
        this.getSectionsToRender().forEach((section) => {
            const sectionElement = section.selector
            ? document.querySelector(section.selector)
            : document.getElementById(section.id);
            
            sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
        });

        crossCheckCartPrices(sessionStorage.getItem('discount-code', sessionDiscount))
        document.dispatchEvent(new Event('cart:updateEvent'));

        initUpsells()

        setTimeout(() => {
            this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
            this.open();
        });

        setTimeout(() => {
            enableCartLines(this)
        }, 300)

        // if (sessionStorage.getItem('upsellDisplayed') === "true") {
        //     this.querySelector('[data-content="drawer-upsells"]').classList.remove('minimized')
        // }
    }

    getSectionInnerHTML(html, selector = '.shopify-section') {

        // let content = sessionStorage.getItem('upsellDisplayed') !== "false"
        //     ? new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML.replace('cart-drawer--upsells minimized', 'cart-drawer--upsells no--animate')
        //     : new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML
        // return content
        return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML
    }

    getSectionsToRender() {
        return [
            {
                id: 'cart-drawer',
                selector: '#CartDrawer',
            },
            {
                id: 'cart-icon-bubble',
            },
        ];
    }

    getSectionDOM(html, selector = '.shopify-section') {
        return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    }

    setActiveElement(element) {
        this.activeElement = element;
    }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
    getSectionsToRender() {
        return [
            {
                id: 'CartDrawer',
                section: 'cart-drawer',
                selector: '.drawer__inner',
            },
            {
                id: 'cart-icon-bubble',
                section: 'cart-icon-bubble',
                selector: '.shopify-section',
            },
        ];
    }
}

customElements.define('cart-drawer-items', CartDrawerItems);

function formatItemProperties(propString) {
    if (!propString || propString === '[]' || propString === '') return {};

    const json = {};

    const properties = JSON.parse(propString)
    properties.forEach(prop => {
        let key = prop[0]
        let value = prop[1]
        json[key] = value
    })

    return cleanJsonValues(json);
}

function cleanJsonValues(obj) {
    for (let key in obj) {
        if (typeof obj[key] === 'string') {
            let parsed = Number(obj[key]);
            if (!isNaN(parsed) && Number.isInteger(parsed)) {
                obj[key] = parsed;
            }
        }
    }
    return obj;
}

function initUpsells() {
    const upsellToggles = document.querySelectorAll('[data-content="drawer-upsell-toggle"]');
    upsellToggles.forEach((toggle) => {
        toggle.addEventListener('click', toggleUpsellState)
    });
}

function toggleUpsellState() {
    const parent = this.closest('[data-content="drawer-upsells"]');
    parent.classList.remove('no--animate')
    parent.classList.toggle('minimized')
    const visible = !parent.classList.contains('minimized')
    sessionStorage.setItem('upsellDisplayed', visible ? 'true' : 'false')
}

function enableCartLines(cart) {
    if (!cart) return;

    const items = cart.querySelectorAll('.cart-item')
    items.forEach(item => {
        const targets = item.querySelectorAll('button, input')
        targets.forEach(target => {
            const disabled = (target.name === 'minus' && target.getAttribute('data-current-value') === '1')
            target.disabled = disabled
        })
        //item.querySelector('.qty-remove--wrapper').classList.remove('hidden')
        //item.querySelector('.load--spin').classList.add('hidden') 
    })
}

document.addEventListener('DOMContentLoaded', () => {
    const cart = document.querySelector('cart-drawer')
    if (!cart) return;

    enableCartLines(cart)
})